//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
  useState,
  useCallback,
  useEffect,
  Fragment,
  useContext,
} from "react";
import * as moment from "moment";
import { toast } from "react-toastify";
import { PDFDownloadLink } from "@react-pdf/renderer";

// custom pages
import { styles } from "./styles";
import report from "apis/Report/Report";
import CiprianReportPDF from "./CiprianReportPDF";
import CiprianReportXLSX from "./CiprianReportXLSX";
import Context from "context/context";
import useDebounce from "helpers/useDebounce";

// material-ui
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import Autocomplete from "@material-ui/lab/Autocomplete";

// material-ui icons
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { withStyles } from "@material-ui/core/styles";
import { parse, format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { enUS, fr } from "date-fns/locale";


const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);
export default function Ciprian(props) {
  const { state, dispatch } = useContext(Context);
  const { page, setDisableDropdown, ReportID } = props;
  const { searchLoyaltyAPI, CiprianReportAPI } = report();
  const { t , i18n} = useTranslation()
  const classes = styles();
  const [states, setstates] = useState({
    columns: [],
    dialog: false,
    data: [],
    excelData: {},
    pdfData: {},
    response: false,
    startDate: parse('01/11/2021', 'dd/MM/yyyy', new Date()),
    endDate: new Date(),
    startDate2: parse('01/11/2018', 'dd/MM/yyyy', new Date()),
    endDate2: new Date(),
    dateApplied: false,
    dateApplied1: false,
    type: "All",
    eLoading: false,
    searchValue: "",
    searchData: [],
    searchLoading: false,
    loyaltyAccount: [],
    excelBtnActive: false,
    pdfBtnActive: false,
    rollingMonth: ""
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const {
    searchLoading,
    searchData,
    searchValue,
    loyaltyAccount,
    excelBtnActive,
    pdfBtnActive,
    rollingMonth
  } = states;

  const searchValueDebounce = useDebounce(searchValue);
  useEffect(() => {
    if (ReportID == 4) {
      setStates({
        rollingMonth: 24,
        startDate: new Date(),
        endDate: new Date(),
        startDate2: parse('01/11/2018', 'dd/MM/yyyy', new Date()),
        endDate2: new Date(),
        dateApplied: false,
        dateApplied1: false,
        loyaltyAccount: []
      });
    }
    else if (ReportID == 5) {
      setStates({
        rollingMonth: 24,
        startDate: new Date(),
        endDate: new Date(),
        startDate2: parse('01/11/2018', 'dd/MM/yyyy', new Date()),
        endDate2: new Date(),
        dateApplied: false,
        dateApplied1: false,
        loyaltyAccount: []
      });
    } else {
      setStates({
        startDate: parse('01/11/2021', 'dd/MM/yyyy', new Date()),
        endDate: new Date(),
        startDate2: parse('01/11/2018', 'dd/MM/yyyy', new Date()),
        endDate2: new Date(),
        dateApplied: false,
        dateApplied1: false,
        loyaltyAccount: []
      });
    }
  }, [ReportID]);




// handling search api call
useEffect(() => {
  if (searchValueDebounce && searchValueDebounce.length > 0) {
    handleSearch();
  }
}, [searchValueDebounce]);

// handleSearch api func
const handleSearch = async () => {
  setStates({ searchLoading: true });
  try {
    let values;
    values = {
      loyaltyId: searchValue,
    };

    let res = await searchLoyaltyAPI(values);
    if (res) {
      setStates({ searchData: res?.data, searchLoading: false });
    }
  } catch (e) {
    console.log({ e });
  }
};

// CustomerStatus api func
const handleGetCustomerStatus = async (type) => {
  try {
    setDisableDropdown(true);
    let values = {};
    if (states.startDate == "Invalid Date" || states.endDate == "Invalid Date" || states?.startDate2 == "Invalid Date" || states.endDate2 == "Invalid Date") {
      toast.error("Invalid Date Format", {
        toastId: "update-error",
      });
      setStates({
        response: true,
        eLoading: false,
      });
      setDisableDropdown(true);

      return;
    }
    values = {
      startDate: moment(states.startDate).format("MM/DD/YYYY"),
      endDate: moment(states.endDate).format("MM/DD/YYYY"),
      loyaltyId: loyaltyAccount?.loyalty_id ? loyaltyAccount?.loyalty_id : "",
      reportID: ReportID,
      rollingMonth: states?.rollingMonth,
      startDate2: moment(states?.startDate2).format("MM/DD/YYYY"),
      endDate2: moment(states?.endDate2).format("MM/DD/YYYY"),
    };
    // console.log(states?.endDate2,"kkkkk",states?.startDate2)
    let res = await CiprianReportAPI(values);
    if (res && res.data.ciprian.length > 0) {
      dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
      if (type === "excel") {
        const convertedArray = (res?.data?.ciprian).map(obj => {
          let k = 0;
          return Object.keys(obj).reduce((acc, key) => {
            k = k + 1;
            const convertedKey = key.replace(/[-\s%]/g, '_');
            // acc[convertedKey] = obj[key];
            acc['value' + k] = obj[key];
            // acc['name'+k] = key;

            return acc;
          }, {});
        });
        const convertedArray1 = (res?.data?.ciprian).map(obj => {
          let k = 0;
          return Object.keys(obj).reduce((acc, key) => {
            k = k + 1;
            // const convertedKey = key.replace(/[-\s%]/g, '_');
            // acc[convertedKey] = obj[key];
            // acc['value' + k] = obj[key];
            acc['name' + k] = key;
            return acc;
          }, {});
        });
        setStates({
          excelData: { ciprian: convertedArray, cipirianName: convertedArray1 },
          response: true,
          eLoading: false,
        });
      }
      else if (type === "pdf") {
        const convertedArray = (res?.data?.ciprian).map(obj => {
          let k = 0;
          return Object.keys(obj).reduce((acc, key) => {
            k = k + 1;
            const convertedKey = key.replace(/[-\s%]/g, '_');
            acc[convertedKey] = obj[key];
            acc['value' + k] = obj[key];
            return acc;
          }, {});
        });
        setStates({
          pdfData: { ciprian: convertedArray },
          response: true,
          eLoading: false,
        });
      }
      setDisableDropdown(false);
      return true;
    }
    else {
      dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
      setStates({
        response: true,
        eLoading: false,
      });
      toast.success(t("No Data Found"), {
        toastId: "no-Data",
      });
      setDisableDropdown(false);
      return false;
    }
  }
  catch (err) {
    console.log(err);
  }
};
const blockInvalidChar = (e) => {
  ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
  if (e.keyCode === 38 || e.keyCode === 40) {
    e.preventDefault();
  }
}

const locale = i18n.language == 'fr' ? fr : enUS;

return (
  <div>
    {ReportID != 5 ?  (
      <>
    <div className={classes.headText}>Select Loyalty Account</div>
    <div className={classes.inputsDiv}>
      <Grid container spacing={0}>
        <Grid item xs={12} md={3}>
          <Autocomplete
            options={searchData}
            getOptionLabel={(obj) => obj?.loyalty_id || ""}
            value={loyaltyAccount || []}
            className={classes.dateInput}
            renderInput={(params) => (
              <TextField
                {...params}
                label={"Loyalty ID"}
                margin="none"
                value={searchValue}
                onChange={(e) => {
                  if (pdfBtnActive) {
                    setStates({
                      searchValue: e.target.value,
                      pdfBtnActive: false,
                    });
                  }
                  setStates({ searchValue: e.target.value });
                }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {searchLoading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
            onChange={(value, obj, reason) => {
              if (reason === "clear") {
                setStates({ searchValue: "", loyaltyAccount: [] });
                return;
              }
              if (obj) {
                setStates({
                  loyaltyAccount: obj,
                  searchValue: obj.value,
                });
              }
            }}
          />
        </Grid>
      </Grid>
    </div>
    </>
):null}
    {
      (ReportID != 4 && ReportID != 5) ?
        <div className={classes.headText}>
          {t('Select date range(Enrollment Member Account Signup)')}{" "}
          {states.dateApplied && (
            <React.Fragment>
              <span className={classes.appliedSpan}>
                <CheckCircleIcon />
              </span>
              <span
                className={classes.removeSpan}
                onClick={() => {
                  if (pdfBtnActive) {
                    setStates({
                      pdfBtnActive: false,
                      dateApplied: false,
                      startDate: parse('01/11/2021', 'dd/MM/yyyy', new Date()),
                      endDate: new Date(),
                    });
                  }
                  setStates({
                    dateApplied: false,
                    startDate: parse('01/11/2021', 'dd/MM/yyyy', new Date()),
                    endDate: new Date(),
                  });
                }}
              >
                {t('Remove')}
              </span>
            </React.Fragment>
          )}
        </div> :
        <div className={classes.headText}>
          {t('Select date')}{" "}
          {states.dateApplied && (
            <React.Fragment>
              <span className={classes.appliedSpan}>
                <CheckCircleIcon />
              </span>
              <span
                className={classes.removeSpan}
                onClick={() => {
                  if (pdfBtnActive) {
                    setStates({
                      dateApplied: false,
                      startDate: new Date(),
                      endDate: new Date(),
                    });
                  }
                  setStates({
                    dateApplied: false,
                    startDate: new Date(),
                    endDate: new Date(),
                  });
                }}
              >
                {t('Remove')}
              </span>
            </React.Fragment>
          )}
        </div>}
    <div className={classes.inputsDiv}>
      <Grid container spacing={0}>
        <Grid item xs={12} md={3}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
            {(ReportID != 4 && ReportID != 5) ?
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                margin="normal"
                label={t("Start Date")}
                id="date-picker-inline"
                className={classes.dateInput}
                value={states.startDate}
                maxDate={new Date()}
                onChange={(date) => {
                  if (pdfBtnActive) {
                    setStates({
                      pdfBtnActive: false,
                    });
                  }
                  if (ReportID != 4 && ReportID != 5) {
                    if (moment(moment(date).format("MM/DD/YYYY")).isAfter(moment(states.endDate).format("MM/DD/YYYY"))) {
                      toast.error("Start date should be greater than End date.", {
                        toastId: "start-date-end-date",
                      });
                      setStates({ startDate: null });
                      return;
                    }
                  }
                  setStates({ startDate: date, dateApplied: true });
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
              /> :
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                margin="normal"
                label={t("Start Date")}
                id="date-picker-inline"
                className={classes.dateInput}
                value={states.startDate}
                onChange={(date) => {
                  if (pdfBtnActive) {
                    setStates({
                      pdfBtnActive: false,
                    });
                  }
                  if (ReportID != 4 && ReportID != 5) {
                    if (moment(moment(date).format("MM/DD/YYYY")).isAfter(moment(states.endDate).format("MM/DD/YYYY"))) {
                      toast.error("Start date should be greater than End date.", {
                        toastId: "start-date-end-date",
                      });
                      setStates({ startDate: null });
                      return;
                    }
                  }
                  setStates({ startDate: date, dateApplied: true });
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
              />}
          </MuiPickersUtilsProvider>
        </Grid>
        {(ReportID != 4 && ReportID != 5) &&
          <Grid item xs={12} md={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} >
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format={"MM/dd/yyyy"}
                margin="normal"
                label={"End Date"}
                id="date-picker-inline2"
                className={classes.dateInput}
                value={states.endDate}
                maxDate={new Date()}
                onChange={(date) => {
                  if (pdfBtnActive) {
                    setStates({
                      pdfBtnActive: false,
                    });
                  }
                  if (moment(moment(date).format("MM/DD/YYYY")).isBefore(moment(states.startDate).format("MM/DD/YYYY")) && ReportID != 4 && ReportID == 5) {
                    toast.error("End date should be greater than Start date.", {
                      toastId: "start-date-end-date",
                    });
                    setStates({ endDate: null });
                    return;
                  }
                  else if (moment(moment(date).format("MM/DD/YYYY")).isAfter(moment(new Date()).format("MM/DD/YYYY")) && ReportID != 4 && ReportID == 5) {
                    setStates({ endDate: null });
                    toast.error("End date should be lesser that future date.", {
                      toastId: "start-date-end-date",
                    });
                    return;
                  }
                  setStates({ endDate: date, dateApplied: true });
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
              />
            </MuiPickersUtilsProvider>
          </Grid>}
        {(ReportID == 4 || ReportID == 5) &&
          <Grid item xs={12} md={3}>
            <TextField
              required
              type="number"
  onWheel={(e) => e.target.blur()}
              onKeyDown={blockInvalidChar}
              InputProps={{
                inputProps: {
                  max: (ReportID == 4) ? 24 : 24,
                  min: 1
                }
              }}
              label={"Rolling Month"}
              className={classes.numberInput}
              margin="none"
              value={rollingMonth}
              onChange={(e) => {
                setStates({ rollingMonth: e.target.value });
              }}
            />
          </Grid>}
      </Grid>
    </div>
    {
      (ReportID == 1 || ReportID == 3) &&
      <div className={classes.headText}>
        Select date range (Sales Post Date)
        {states.dateApplied1 && (
          <React.Fragment>
            <span className={classes.appliedSpan}>
              <CheckCircleIcon />
            </span>
            <span
              className={classes.removeSpan}
              onClick={() => {
                if (pdfBtnActive) {
                  setStates({
                    pdfBtnActive: false,
                    dateApplied1: false,
                    startDate2: parse('01/11/2018', 'dd/MM/yyyy', new Date()),
                    endDate2: new Date(),
                  });
                }
                setStates({
                  dateApplied1: false,
                  startDate2: parse('01/11/2018', 'dd/MM/yyyy', new Date()),
                  endDate2: new Date(),
                });
              }}
            >
              {t('Remove')}
            </span>
          </React.Fragment>
        )
        }
      </div >}
    {/* {
      (ReportID == 1 || ReportID == 3) &&
      <div className={classes.inputsDiv}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                margin="normal"
                label={t("Start Date")}
                id="date-picker-inline"
                className={classes.dateInput}
                value={states.startDate2}
                maxDate={new Date()}
                onChange={(date) => {
                  if (pdfBtnActive) {
                    setStates({
                      pdfBtnActive: false,
                    });
                  }
                  if (moment(moment(date).format("MM/DD/YYYY")).isAfter(moment(states.endDate2).format("MM/DD/YYYY"))) {
                    toast.error("Start date should be greater than End date.", {
                      toastId: "start-date-end-date",
                    });
                    setStates({ startDate2: null });
                    return;
                  }
                  setStates({ startDate2: date, dateApplied1: true });
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
      </div>} */}
    {(ReportID == 1 || ReportID == 3) &&
      <div className={classes.inputsDiv}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} >
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format={"MM/dd/yyyy"}
                margin="normal"
                label={"Start Date"}
                id="date-picker-inline"
                className={classes.dateInput}
                value={states.startDate2}
                maxDate={new Date()}
                onChange={(date) => {
                  if (pdfBtnActive) {
                    setStates({
                      pdfBtnActive: false,
                    });
                  }
                  if (moment(moment(date).format("MM/DD/YYYY")).isAfter(moment(states.endDate2).format("MM/DD/YYYY"))) {
                    toast.error("Start date should be greater than End date.", {
                      toastId: "start-date-end-date",
                    });
                    setStates({ startDate2: null });
                    return;
                  }
                  setStates({ startDate2: date, dateApplied1: true });
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
              />
            </MuiPickersUtilsProvider>
          </Grid>
          {ReportID != 4 &&
            <Grid item xs={12} md={3}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} >
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format={"MM/dd/yyyy"}
                  margin="normal"
                  label={"End Date"}
                  id="date-picker-inline2"
                  className={classes.dateInput}
                  value={states.endDate2}
                  maxDate={new Date()}
                  onChange={(date) => {
                    if (pdfBtnActive) {
                      setStates({
                        pdfBtnActive: false,
                      });
                    }
                    if (moment(moment(date).format("MM/DD/YYYY")).isBefore(moment(states.startDate2).format("MM/DD/YYYY"))) {
                      toast.error("End date should be greater than Start date.", {
                        toastId: "start-date-end-date",
                      });
                      setStates({ endDate2: null });
                      return;
                    }
                    else if (moment(moment(date).format("MM/DD/YYYY")).isAfter(moment(new Date()).format("MM/DD/YYYY"))) {
                      setStates({ endDate2: null });
                      toast.error("End date should be lesser that future date.", {
                        toastId: "start-date-end-date",
                      });
                      return;
                    }
                    setStates({ endDate2: date, dateApplied1: true });
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  autoOk
                />
              </MuiPickersUtilsProvider>
            </Grid>}

        </Grid>
      </div>}

    <div className={classes.exportAndPreview}>
      <Button
        className={classes.exportBtn}
        onClick={async () => {
          // if (!loyaltyAccount?.loyalty_id) {
          //   toast.error("Please select the Member Account", {
          //     toastId: "loyalty-empty",
          //   });
          //   return;
          // }
          if (ReportID != 4) {
            if (
              (states?.startDate && !states.endDate) ||
              (!states?.startDate && states.endDate) ||
              (!states?.startDate && !states.endDate)
            ) {
              toast.error(
                "Please select the both Start-date and End-date values",
                {
                  toastId: "empty-fields",
                }
              );
              return;
            }
          }
          if (ReportID == 4 && states?.rollingMonth == "") {
            toast.error(
              "Please enter Rolling Month values",
              {
                toastId: "empty-fields",
              }
            );
            return;
          }
          if (ReportID == 4 && (states?.rollingMonth > 24 || states?.rollingMonth <= 0)) {
            toast.error(
              "Rolling Month should be 1-24",
              {
                toastId: "empty-fields",
              }
            );
            return;
          }
          if (ReportID == 5 && (states?.rollingMonth > 24 || states?.rollingMonth <= 0)) {
            toast.error(
              "Rolling Month should be 1-24",
              {
                toastId: "empty-fields",
              }
            );
            return;
          }
          if (
            states?.startDate?.toString() === "Invalid Date" &&
            states?.endDate?.toString() === "Invalid Date"
          ) {
            toast.error("Invalid date.", {
              toastId: "invalid-date",
            });
            setStates({ startDate: new Date(), endDate: new Date() });
            return;
          } else if (states?.startDate?.toString() === "Invalid Date") {
            toast.error("Invalid start date.", {
              toastId: "invalid-s-date",
            });
            setStates({ startDate: new Date() });
            return;
          } else if (states.endDate?.toString() === "Invalid Date") {
            toast.error("Invalid end date.", {
              toastId: "invalid-e-date",
            });
            setStates({ endDate: new Date() });
            return;
          }

          setStates({
            response: false,
            excelData: [],
            eLoading: true,
            excelBtnActive: true,
            pdfBtnActive: false,
          });
          let res = await handleGetCustomerStatus("excel");
          if (res) {
            // console.log("csv read",res)
            document.getElementById("csv").click();
          }
        }}
        disabled={states.eLoading}
      >
        {states.eLoading && states.excelBtnActive ? (
          <React.Fragment>
            <CircularProgress
              style={{ height: 25, width: 25 }}
              variant="determinate"
              value={state.reportResCount}
            />{" "}
            &nbsp;
            <span style={{ color: "#305698", fontWeight: "bold" }}>
              {state.reportResCount == 0 ? (
                <div class="snippet">
                  <div class="stage">
                    <div class="dot-typing-e"></div>
                  </div>
                </div>
              ) : (
                `${state.reportResCount}%`
              )}
            </span>
          </React.Fragment>
        ) : (
          "Export as excel"
        )}
      </Button>
      <CiprianReportXLSX
        states={states}
        date={
          moment(moment(states?.startDate).format("MM/DD/YYYY")).isSame(
            moment(states?.endDate).format("MM/DD/YYYY")
          )
            ? `Date : ${moment(states?.startDate).format("MM/DD/YYYY")}`
            : `Date : ${moment(states?.startDate).format(
              "MM/DD/YYYY"
            )} to ${moment(states?.endDate).format("MM/DD/YYYY")}`
        }
        page={page}
        reportId={ReportID}
      />
      {/* <Button
          className={classes.exportBtn}
          onClick={async () => {
            // if (!loyaltyAccount?.loyalty_id) {
            //   toast.error("Please select the Member Account", {
            //     toastId: "loyalty-empty",
            //   });
            //   return;
            // }
            if (
              (states.startDate && !states.endDate) ||
              (!states.startDate && states.endDate) ||
              (!states.startDate && !states.endDate)
            ) {
              toast.error(
                "Please select the both Start-date and End-date values",
                {
                  toastId: "empty-fields",
                }
              );
              return;
            }
            if (
              states.startDate?.toString() === "Invalid Date" &&
              states.endDate?.toString() === "Invalid Date"
            ) {
              toast.error("Invalid date.", {
                toastId: "invalid-date",
              });
              setStates({ startDate: new Date(), endDate: new Date() });
              return;
            } else if (states.startDate?.toString() === "Invalid Date") {
              toast.error("Invalid start date.", {
                toastId: "invalid-s-date",
              });
              setStates({ startDate: new Date() });
              return;
            } else if (states.endDate?.toString() === "Invalid Date") {
              toast.error("Invalid end date.", {
                toastId: "invalid-e-date",
              });
              setStates({ endDate: new Date() });
              return;
            }

            setStates({
              response: false,
              pdfData: [],
              eLoading: true,
              excelBtnActive: false,
              pdfBtnActive: true,
            });
            let res = await handleGetCustomerStatus("pdf");
          }}
          disabled={states.eLoading}
        >
          {states.eLoading && states.pdfBtnActive ? (
            <React.Fragment>
              <CircularProgress
                style={{ height: 25, width: 25 }}
                variant="determinate"
                value={state.reportResCount}
              />{" "}
              &nbsp;
              <span style={{ color: "#305698", fontWeight: "bold" }}>
                {state.reportResCount == 0 ? (
                  <div class="snippet">
                    <div class="stage">
                      <div class="dot-typing-e"></div>
                    </div>
                  </div>
                ) : (
                  `${state.reportResCount}%`
                )}
              </span>
            </React.Fragment>
          ) : t(
            "Export as pdf"
          )}
        </Button> */}
      {Object.keys(states.pdfData).length > 0 && states?.pdfBtnActive && (
        <PDFDownloadLink
          style={{ display: "none" }}
          document={
            <CiprianReportPDF
              states={states}
              date={
                moment(moment(states?.startDate).format("MM/DD/YYYY")).isSame(
                  moment(states?.endDate).format("MM/DD/YYYY")
                )
                  ? `Date : ${moment(states?.startDate).format("MM/DD/YYYY")}`
                  : `Date : ${moment(states?.startDate).format(
                    "MM/DD/YYYY"
                  )} to ${moment(states?.endDate).format("MM/DD/YYYY")}`
              }
              setStates={setStates}
              reportId={ReportID}
            />
          }
          fileName={
            `${page.replace(/ /g, "")}` +
            " " +
            moment(new Date()).format("MM-DD-YYYY,h:mm A")
          }

        >
          <button id="download-pdf"></button>
        </PDFDownloadLink>
      )}
    </div>
  </div>
);
        }

